import React from "react";
import { Modal,Spinner } from "react-bootstrap";
import {Form, Container} from "react-bootstrap";
import ColDynamic from "../EntryForms/WrapperComponents/ColDynamic";
import "../../containers/ControlMeasures/ControlMeasures.css";
import DatePicker from "../UI/DatePicker/DatePicker";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
import InputComponent from "../UI/InputComponent/InputComponent";
import Upload from "../UI/Upload/Upload";
import UploadComponent from "../UI/Upload/UploadComponent";
import Dropdown from "../UI/Dropdown/Dropdown";
import ModalComponent from "../UI/Modal/Modal";
import moment from "moment";

const UnosUpravnogSpora = (props) => {

  return (
    <>
      <ModalComponent
        size="l"
        show={props.modalUpravniSpor}
        onHide={props.hideModalUpravniSpor}
        className="heder"
        centered
        title="Unos upravnog spora"
      >
        <Modal.Body>
          <div className="justify-content-center" key={"form"}>
            <div className="align-self-center modal-mjere">
              <Form onSubmit={props.submitHandlerUS}>
               <div>
          
                <label>Upravni spor</label>
               
                <div  className="unos_upload">
                  <UploadComponent
                   
                    key={"testUS"}
                    id={"testIdUS"}
                    onChange={props.uploadHandlerUS}
                    fileList={props.formDataUS.selectedFile}
                    style={
                      props.error &&
                      props.formDataUS.selectedFile.length < 1 &&
                      "red"
                    }
                  />
                </div>

                <InputComponent
                  id="note"
                  value={props.formDataUS.note}
                  onChange={props.userInputFormHandlerUS}
                  controlLabel={"Upravni spor - napomena"}
                  className="input-modal"
                  name="napomena"
                />
                </div>

                <div className="row" key={"button"}>
                  <div className="col-md-6">
                    <ButtonComponent
                      type="submit"
                      block={true}
                      variant="primary"
                      //  onClick={this.hideModal}
                      disabled={props.loaderUS}
                      
                    >
                      {props.loaderUS ? 
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      /> 
                      :
                      (<p>Spremi</p>)}
                    </ButtonComponent>
                  </div>
                  <div className="col-md-6">
                    <ButtonComponent
                      onClick={props.hideModalUpravniSpor}
                      block={true}
                      variant="danger"
                    >
                      Odustani
                    </ButtonComponent>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </Modal.Body>
      </ModalComponent>
    </>
  );
};

export default UnosUpravnogSpora;